/* Eurorox Atelier — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: {}, strings: {} };

  /* ---------------------------------------------------------------
     Header: scrolled state + search panel
  --------------------------------------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var panel = $('#SearchPanel');
    $$('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!panel) return;
        e.preventDefault();
        panel.hidden = !panel.hidden;
        if (!panel.hidden) { var input = $('input[type="search"]', panel); input && input.focus(); }
      });
    });
    $$('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { panel.hidden = true; });
    });
  }

  /* ---------------------------------------------------------------
     Drawers (mobile nav + cart)
  --------------------------------------------------------------- */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    window.setTimeout(function () { panel && panel.focus(); }, 60);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
      var cartOpen = e.target.closest('[data-cart-open]');
      var cartDrawer = $('#CartDrawer');
      if (cartOpen && cartDrawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer(cartDrawer); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = $('[data-drawer].is-open');
      if (open) closeDrawer(open);
      var panel = $('#SearchPanel');
      if (panel && !panel.hidden) panel.hidden = true;
    });
    // Simple focus trap
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var open = $('[data-drawer].is-open .drawer__panel');
      if (!open) return;
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select', open).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------------------------------------------------------
     Reveal on scroll
  --------------------------------------------------------------- */
  function initReveal() {
    var items = $$('.reveal:not(.is-visible)');
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------
     Quantity steppers (delegated)
  --------------------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-quantity]');
      var input = wrap && $('input', wrap);
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var val = parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
      input.value = Math.max(min, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------------
     Product gallery
  --------------------------------------------------------------- */
  function initGallery(gallery) {
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var dots = $$('.gallery__dot', gallery);
    var thumbs = $$('[data-thumb-index]', gallery);

    var setActive = function (i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    };
    var goTo = function (i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    };
    var current = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { setActive(current()); ticking = false; });
    }, { passive: true });

    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb-index'), 10)); }); });
    var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
    prev && prev.addEventListener('click', function () { goTo(current() - 1); });
    next && next.addEventListener('click', function () { goTo(current() + 1); });

    // Click-to-zoom on desktop pointers
    if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      $$('[data-zoom]', gallery).forEach(function (z) {
        var img = $('img', z);
        z.addEventListener('click', function () { z.classList.toggle('is-zoomed'); });
        z.addEventListener('mousemove', function (e) {
          if (!z.classList.contains('is-zoomed') || !img) return;
          var r = z.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        z.addEventListener('mouseleave', function () { z.classList.remove('is-zoomed'); });
      });
    }

    gallery.goToMedia = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    };
  }

  /* ---------------------------------------------------------------
     Variant selection
  --------------------------------------------------------------- */
  function initProductSection(section) {
    var id = section.getAttribute('data-product-section');
    var jsonEl = document.querySelector('[data-product-json="' + id + '"]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var picker = $('[data-variant-picker]', section);
    if (!picker) return;

    var readOptions = function () {
      var opts = [];
      $$('[data-option-index]', picker).forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        opts[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return opts;
    };

    picker.addEventListener('change', function (e) {
      var fieldset = e.target.closest('fieldset');
      if (fieldset) { var label = $('[data-selected-value]', fieldset); if (label) label.textContent = e.target.value; }
      var opts = readOptions();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      updateVariant(section, data, variant);
    });
  }

  function updateVariant(section, data, variant) {
    var btns = $$('[data-add-to-cart]', section).concat($$('[data-sticky-button]'));
    var inputs = $$('[data-variant-id]', section);
    if (!variant) {
      btns.forEach(function (b) { b.disabled = true; var t = $('[data-add-to-cart-text]', b) || b; t.textContent = theme.strings.unavailable; });
      return;
    }
    inputs.forEach(function (i) { i.value = variant.id; });
    btns.forEach(function (b) {
      b.disabled = !variant.available;
      var t = $('[data-add-to-cart-text]', b) || b;
      t.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
    });

    $$('[data-price]', section).forEach(function (p) {
      var cur = $('[data-price-current]', p), cmp = $('[data-price-compare]', p), badge = $('[data-price-badge]', p);
      if (cur) cur.textContent = variant.price;
      if (cmp) { cmp.hidden = !variant.compare; var s = $('s', cmp); if (s && variant.compare) s.textContent = variant.compare; }
      if (badge) { badge.hidden = !variant.save; badge.textContent = badge.textContent.replace(/\d+/, variant.save); }
    });
    var sp = $('[data-sticky-price]'); if (sp) sp.textContent = variant.price;

    if (variant.media) { var g = $('[data-gallery]', section); if (g && g.goToMedia) g.goToMedia(variant.media); }
    if (document.body.classList.contains('template-product') && window.history.replaceState) {
      window.history.replaceState({}, '', data.url + '?variant=' + variant.id);
    }
  }

  /* ---------------------------------------------------------------
     Cart (AJAX add + drawer rendering)
  --------------------------------------------------------------- */
  function renderDrawer(html) {
    var drawer = $('#CartDrawer');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer .drawer__panel');
    var panel = $('.drawer__panel', drawer);
    if (fresh && panel) panel.innerHTML = fresh.innerHTML;
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-empty', count === 0); });
  }
  function refreshCount() {
    return fetch((theme.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      if (document.body.getAttribute('data-cart-type') !== 'drawer' || !$('#CartDrawer')) return; // native submit → cart page
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var errorEl = $('[data-form-error]', form);
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      fetch((theme.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            var msg = res.json.description || res.json.message || theme.strings.error;
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
            return;
          }
          if (res.json.sections) renderDrawer(res.json.sections['cart-drawer']);
          refreshCount();
          openDrawer($('#CartDrawer'));
        })
        .catch(function () { if (errorEl) { errorEl.textContent = theme.strings.error; errorEl.hidden = false; } })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
    });
  }

  function changeLine(line, quantity) {
    var drawerPanel = $('#CartDrawer .drawer__panel');
    drawerPanel && drawerPanel.classList.add('is-updating');
    return fetch((theme.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
        if (typeof cart.item_count === 'number') updateCount(cart.item_count);
        return cart;
      })
      .finally(function () { drawerPanel && drawerPanel.classList.remove('is-updating'); });
  }

  function initCartLines() {
    var debounce;
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      var line = parseInt(input.getAttribute('data-line-qty'), 10);
      var qty = Math.max(0, parseInt(input.value || '0', 10));
      window.clearTimeout(debounce);
      debounce = window.setTimeout(function () {
        var onPage = input.closest('[data-cart-page]');
        changeLine(line, qty).then(function () { if (onPage) window.location.reload(); });
      }, 350);
    });
    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-line-remove]');
      if (!remove || !remove.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      changeLine(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
    });
  }

  /* ---------------------------------------------------------------
     Sticky add to cart
  --------------------------------------------------------------- */
  function initStickyATC() {
    var bar = $('[data-sticky-atc]');
    var target = $('[data-main-buy]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var footer = $('.site-footer');
    var mainVisible = true, footerVisible = false;
    var update = function () {
      var show = !mainVisible && !footerVisible && target.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = $('[data-sticky-button]', bar); if (b) b.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; update(); }).observe(target);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
  }

  /* ---------------------------------------------------------------
     Boot + Theme editor support
  --------------------------------------------------------------- */
  function initSections(root) {
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product-section]', root).forEach(initProductSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initDrawers();
    initQuantity();
    initAddToCart();
    initCartLines();
    initSections(document);
    initStickyATC();
    initReveal();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initSections(e.target);
    initReveal();
    if (e.target.querySelector('[data-header]')) initHeader();
    if (e.target.querySelector('[data-sticky-atc]')) initStickyATC();
  });
  document.addEventListener('shopify:section:select', function (e) {
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest('details'); if (d) d.open = true;
    if (e.target.matches('details')) e.target.open = true;
  });
})();
